import {
  APPROVED_CATEGORIES_LIST_RESPONSE,
  GET_CATEGORY_DETAILS_RESPONSE,
  CATEGORY_SUB_CATEGORIES_LIST_RESPONSE,
  REQUESTS_CATEGORIES_LIST_RESPONSE,
  GET_CATEGORY_REQUEST_DETAILS_RESPONSE
} from "./types";

const INITIAL_STATE = {
  approvedCategories: {
    list: [],
    meta: {}
  },
  categoryDetails: {},
  categorySubCategories: {
    list: [],
    meta: {}
  },
  requestsCategories: {
    list: [],
    meta: {}
  },
  categoryRequestDetails: {}
};

const categories = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case APPROVED_CATEGORIES_LIST_RESPONSE:
      return {
        ...state,
        approvedCategories: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case GET_CATEGORY_DETAILS_RESPONSE:
      return {
        ...state,
        categoryDetails: action.payload
      };
    case CATEGORY_SUB_CATEGORIES_LIST_RESPONSE:
      return {
        ...state,
        categorySubCategories: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case REQUESTS_CATEGORIES_LIST_RESPONSE:
      return {
        ...state,
        requestsCategories: {
          list: action.payload.list,
          meta: action.payload.meta
        }
      };
    case GET_CATEGORY_REQUEST_DETAILS_RESPONSE:
      return {
        ...state,
        categoryRequestDetails: action.payload
      };
    default:
      return state;
  }
};

export default categories;
